import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getBrands from '../../services/brand/getBrands'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchBrands ({ dossierSubTypeId, organizedUnitId, includeDeleted }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const brandCombo = yield call(getBrands, auth.token, dossierSubTypeId, organizedUnitId, includeDeleted)
    yield put(fetchCombosSuccess({ brandCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchBrands () {
  yield takeLatest(combosActionTypes.FETCH_BRANDS, fetchBrands)
}
